import React, {Component} from 'react';
import {CUSTOMIZED_REPORT} from '../../resources/constant';
import {getListCustServiceForm, getAllFilesByReportTypes} from '../../Utilities/WSUtil';
import {retentionYears, allMonths, allDays, zeroPad} from '../../Utilities/DatePicker';
import {Row,Col,Form} from 'react-bootstrap';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn} from '../../theme/MorsTheme';

export default class SearchCustomerServiceReport extends Component{

    constructor(props){
        super(props);        
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleChange = this.toggleChange.bind(this);
        this.state = {            
            checkedAllReport:false, 
            searchSingleId: '',            
            serviceForms:[]
        };
    }  
        
    componentWillMount(){
        getListCustServiceForm()
        .then(response => {            
            this.setState({serviceForms: response});
        })         
    }

    toggleChange = () => {
        this.setState({
            checkedAllReport: !this.state.checkedAllReport
        });
      }
        
    handleChange(e){
        this.setState(
            {                
                [e.target.id]: e.target.value   
            }
        )
    }
   
    handleSubmit(event) {
        event.preventDefault();                  
        var date_From = document.getElementById('fromMonth').value+
        '/'+document.getElementById('fromDay').value +
        '/'+document.getElementById('fromYear').value;

        var date_To = document.getElementById('toMonth').value +
        '/'+document.getElementById('toDay').value +
        '/'+document.getElementById('toYear').value;
                
        if(this.state.searchSingleId === '0' && this.state.checkedAllReport === false){
           alert('Please select Folder Name');                     
        }else{                    
            getAllFilesByReportTypes(                      
                this.props.currentUser.userId,
                this.props.currentUser.groupId,
                "1",          
                "1",
                date_From,
                date_To,            
                CUSTOMIZED_REPORT,            
                this.state.searchSingleId,            
                this.state.checkedAllReport
            ).then(response => {    
                this.props.getTypeReport(CUSTOMIZED_REPORT);            
                this.props.getReports(response);            
                this.props.history.push("/reportsFileList");
            })
        }    
    }

    render(                      
    ){                          
        return(                               
	    <div>	
            <BodyHeaderDiv>
                <BodyHeaderText>Search Customer Service Report</BodyHeaderText>
            </BodyHeaderDiv>
            <ContentDiv>
            <Row>
                <Col md={3}></Col>                
                <Col md={6}>
                <Form onSubmit={this.handleSubmit}>                          

                    <Form.Label size='sm'>Inclusive Dates</Form.Label>
                    <Form.Row>                                                
                        <Form.Group as={Col} controlId="fromMonth" onChange={this.handleChange}>                                                            
                            <Form.Control as="select" size='sm'>
                            {   allMonths.map((option, index) =>                             
                                <option key={index} value={option.id}>{option.month}</option> )  
                            }                              
                            </Form.Control>                                                                
                        </Form.Group>
                        <Form.Group as={Col} controlId="fromDay" onChange={this.handleChange}>                                                                                            
                            <Form.Control as="select" size='sm'>
                            {   allDays.map((option, index) =>                                 
                                <option key={index} value={zeroPad(option,2)}>{option}</option>)
                            }                             
                            </Form.Control>                                                                
                        </Form.Group>
                        <Form.Group as={Col} controlId="fromYear" onChange={this.handleChange}>                                                                                            
                            <Form.Control as="select" size='sm'>
                            {   retentionYears.sort((a,b) => a < b).map((option, index) =>                                                                                              
                                <option key={index} value={option}>{option}</option>)
                            }                            
                            </Form.Control>                                                                
                        </Form.Group>                                                         
                    </Form.Row>
                    <Form.Label>To</Form.Label>
                    <Form.Row>
                        <Form.Group as={Col} controlId="toMonth" onChange={this.handleChange}>
                            <Form.Control as="select" size='sm' >
                            {   allMonths.map((option, index) =>
                                <option key={index} value={option.id}>{option.month}</option>)                          
                            } 
                            </Form.Control>                            
                        </Form.Group>
                        <Form.Group as={Col} controlId="toDay" onChange={this.handleChange}>
                            <Form.Control as="select" size='sm' >
                            {   allDays.map((option, index) => 
                                <option key={index} value={zeroPad(option,2)}>{option}</option>)
                            } 
                            </Form.Control>                            
                        </Form.Group>
                        <Form.Group as={Col} controlId="toYear" onChange={this.handleChange}>
                            <Form.Control as="select" size='sm' >
                            {   retentionYears.sort((a,b) => a < b).map((option, index) =>                                   
                                <option key={index} value={option}>{option}</option>)
                            } 
                            </Form.Control>                            
                        </Form.Group>
                    </Form.Row>                          
                    <Form.Row>
                    <Form.Group as={Col} controlId="searchSingleId" onChange={this.handleChange}>
                        <Form.Label>Report Name</Form.Label>
                        <Form.Control as="select" size='sm' >
                            <option value={0}>Please Select</option>
                                {
                                this.state.serviceForms.map((option, index) => 
                                <option key={index} value={option.formName}>{option.formName}</option> )  
                                } 
                        </Form.Control>                            
                    </Form.Group>
                    </Form.Row>
                    
                    <Form.Row>
                    <Form.Group as={Col} controlId="searchSingleId" onChange={this.handleChange}>
                        <Form.Label>Reference Number</Form.Label>
                        <Form.Control type="text" size="sm">                            
                        </Form.Control>
                    </Form.Group>
                    </Form.Row>                         
                    <div align="center">
                        <SubmitBtn>View Reports</SubmitBtn> 
                    </div>
                </Form>  
                </Col>
                <Col md={3}>
            </Col>
        </Row>
    </ContentDiv>                   
</div>
        )
    }
}


